<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-12-21 21:11:52
 * @LastEditTime: 2022-07-29 14:33:12
 * @LastEditors: chenguobiao
-->
<template>
  <div class="dialog" v-if="visible">
    <div class="dialog__masker"></div>
    <div class="dialog__box">
      <!-- <div class="dialog__bg">
        <img src="@/render/assets/images/personal/dialog_bg.png">
      </div> -->
      <div class="dialog__desc">
        <p>步法错误，若再出现一次，将失去本题分数。</p>
        <p>
          错误走法：<span>{{ step }}</span>
        </p>
      </div>
      <div class="dialog__options">
        <div class="option" @click="confirm">知道了</div>
      </div>
    </div>
  </div>
</template>

<script>
import dialogMixin from '@/render/components/dialog/mixin'
export default {
  mixins: [dialogMixin],
  props: {
    step: {
      type: String,
      require: true,
    },
  },
}
</script>

<style lang="scss" scoped>
@import './dialog.scss';
.dialog {
  &__box {
    width: val(400) !important;
    height: val(200);
    background: url(../../assets/images/dialog/dialog_bg_01.png) left top
      no-repeat;
    background-size: 100%;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__desc {
    position: relative;
    top: val(10);
    padding: 0 val(46);
    line-height: val(24);
    font-size: val(18);
    color: #502700;
    ::v-deep span {
      color: red;
    }
  }
  &__options {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    margin-bottom: val(-21);
    display: flex;
    justify-content: center;
    .option {
      width: val(120);
      line-height: val(42);
      border-radius: val(37);
      font-size: val(18);
      text-align: center;
      color: #fff;
      background: linear-gradient(360deg, #b26113 0%, #fdae5f 100%);
    }
  }
}
</style>
